import { FeatureFlagKey } from "encamp-shared/src/featureFlags";
import { Permission } from "generated-graphql/graphql";
import { useAuthorization } from "hooks/useAuthorization";
import { useCurrentUser } from "hooks/useCurrentUser";
import { useFeatureFlags } from "hooks/useFeatureFlags";

/** Whether the signed-in user may pick their own facilities: the org allows it and their role holds EditOwnFacilityPermissions. */
export function useCanSelfAssignFacilities(): boolean {
  const { hasPermissions } = useAuthorization();
  const { featureFlags } = useFeatureFlags();

  return (
    hasPermissions([Permission.EditOwnFacilityPermissions]) &&
    !!featureFlags[FeatureFlagKey.FacilitySelfAssignment]
  );
}

/**
 * Whether the signed-in user may change `editedUserId`'s facilities: an org admin, or the user
 * themselves when they can self-assign. Mirrors the API's rule for `upsertUserFacilitiesForTenant`.
 */
export function useCanLinkFacilities(editedUserId: string | null | undefined): boolean {
  const { hasPermissions } = useAuthorization();
  const { user } = useCurrentUser();
  const canSelfAssign = useCanSelfAssignFacilities();

  const editingSelf = !!user && user.id === editedUserId;
  return hasPermissions([Permission.WriteAllUserTenant]) || (editingSelf && canSelfAssign);
}
